import { SalaryRowsProps, SalaryVisibility } from './constants'
import { SalaryMobileRow } from './salary-mobile-row'
import { SalaryRowHintMobile } from './salary-row-hint'
import { isShowRowHintRow, useShowRowHint } from './use-show-row-hint'

export function SalaryTableMobile({
  salaries,
  blurTotalCompensation,
  onRowClick,
  showTableRowHint,
  isLocumsOrPrn,
  isHourlyPayPeriod,
}: SalaryRowsProps & {
  isLocumsOrPrn?: boolean
  isHourlyPayPeriod?: boolean
}) {
  const { salariesWithRowHint } = useShowRowHint({
    showTableRowHint,
    salaries,
    blurTotalCompensation,
    salaryVisibility: salaries?.[0]?.visibility,
  })

  return (
    <ul className="bg-background-primary">
      {salariesWithRowHint.map((salary, index) => {
        if (isShowRowHintRow(salary)) {
          return <SalaryRowHintMobile key={index} />
        }

        return (
          <li key={salary.salaryId}>
            <SalaryMobileRow
              salary={salary}
              index={index}
              className="rounded-none border-x-0 hover:bg-table-tr-hover-bg"
              blurTotalCompensation={
                blurTotalCompensation ||
                salary.visibility === SalaryVisibility.Restricted ||
                salary.visibility === SalaryVisibility.None
              }
              onRowClick={onRowClick}
              isLocumsOrPrn={isLocumsOrPrn}
              isHourlyPayPeriod={isHourlyPayPeriod}
            />
          </li>
        )
      })}
    </ul>
  )
}
